export const buildSearch = ({ city, q, date }) => {
    let search = '?';
    search += city ? `city=${city}&` : '';
    search += q ? `q=${q}&` : '';
    search += date ? `date=${date}&` : '';

    return search;
};
